import { baseServiceRequest } from "@apis/baseServiceRequest"
import type {
  IApproveRewardsRequest,
  IVendorRewards,
  IPendingRewards,
  IAllRewards,
  IPromo,
  IAccountPromoReason,
  IReissueRewardRequest,
} from "./types"

export const getAllRewards = async (): Promise<IAllRewards[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/rewards/summary`,
  })
  return response.data.pending.vendors
}

export const getVendorRewards = async (
  fulfillmentVendorCode: string,
): Promise<IVendorRewards> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/rewards/summary/vendors/${fulfillmentVendorCode}`,
  })
  return response.data
}

export const getPendingRewards = async (
  fulfillmentVendorCode: string,
  fulfillmentChannel: string,
): Promise<IPendingRewards> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/rewards/pending?fulfillment_vendor_code=${fulfillmentVendorCode}&fulfillment_channel=${fulfillmentChannel}`,
  })
  return response.data
}

export const approvePendingRewards = async (data: IApproveRewardsRequest) => {
  return baseServiceRequest({
    method: "POST",
    url: `/rewards/pending/approve`,
    data,
  })
}

export const getAvailablePromos = async (): Promise<IPromo[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/rewards/promos`,
  })
  return response.data
}

export const getPromoReasons = async (): Promise<IAccountPromoReason[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/rewards/promos/reasons`,
  })
  return response.data
}

export const resendReward = async ({reward_guid, data}: IReissueRewardRequest) => {
  return baseServiceRequest({
    method: "POST",
    url: `rewards/${reward_guid}/resend`,
    data,
  })
}

export const redeemReward = async ({reward_guid, data}: IReissueRewardRequest) => {
  return baseServiceRequest({
    method: "POST",
    url: `rewards/${reward_guid}/redeem`,
    data,
  })
}
